import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ENV } from "@app/env";
import { Observable } from "rxjs/Observable";
import { catchError, retry } from "rxjs/operators";
import { Utilities } from "./utilities";

@Injectable()
export class EmailProvider {

  constructor(
    private http: HttpClient,
    private utilities: Utilities,
  ) { }

  /**
   * Consume el servicio Backend de envio de correos genericos
   *
   * @param template  String que se toma de la base de datos refunde_email[0] | refuse_email[0] | success_email[0]
   * @param to        Array de usuarios a quien va dirigido el correo
   * @param subjet    String del asunto segun la operacion
   * @param from      String que se toma de la base de datos  from_email
   * @param params    Objeto en donde se incluyen los parametros necesarios para el contenido del correo
   *                  para el caso de ejemplo debe ir { description: 'content accept html labels' }
   *                  Content example:
   *                                     <h2>Heading email</h2>
   *                                     <ul>
   *                                       <li>List 1</li>
   *                                       <li>List 2</li>
   *                                       <li>List 3</li>
   *                                     </ul>
   *                                     <p>
   *                                       <a href="gooogle.com">Link</a>
   *                                     </p>
   *                                     <p>
   *                                       <img style="margin: 0 auto; max-height: 80px; width: auto;"
   * src="https://barcode.tec-it.com/barcode.ashx?data=123456&code=Code128&dpi=96&dataseparator=">
   *                                     </p>
   *
   */
  public sendEmail(template: string, params: any, to: string[], subjet: string, from: string): Observable<any> {
    const payload = { params, template, to, subjet, from };
    return this.http.post(`${ENV.backend}/notification/mail`, payload)
      .do(() => this.utilities.consoleDecorator("Sending email: ", payload, "#004d40"))
      .pipe(retry(3), catchError((err) => [this.utilities.consoleDecorator("Error sending email: ", err, "#004d40")]));
  }
}



// WEBPACK FOOTER //
// ./src/providers/email.ts